<template>
    <nav class="top-menu">
        <div class="right">
            <v-switch v-model="model" :label="''" hide-details inset @change="toggleTheme"></v-switch>
        </div>

        <div class="left">
            <img :src="logo" alt="Logo Refrisat" class="logo" />
        </div>

        <div class="box-input center" v-if="isRotaEspecifica">
            <v-text-field v-model="message" label="Pesquise pelo nome do cliente ou do equipamento"
                prepend-inner-icon="mdi-magnify" clear-icon="mdi-close-circle" density="compact" hide-details
                single-line clearable @update:modelValue="atualizarFiltro" @click:clear="clearMessage" />
        </div>

        <div v-if="!isRotaEspecifica" class="box-nome-pagina">
        </div>
    </nav>
</template>

<script>
    import { ref } from "vue";
    import { eventBus } from "./core/EventBus";
    import logoSrc from "@/assets/refrisat_b.png";

    export default {
        name: "MenuSuperior",
        data() {
            return {
                model: ref(localStorage.getItem("theme") === "dark").value
            };
        },
        computed: {
            isRotaEspecifica() {
                return this.$route.name === 'Lista Equipamentos';
            },
            getRouteName() {
                return this.$route.name;
            }
        },
        setup() {
            const isDarkMode = ref(localStorage.getItem("theme") === "dark");
            const message = ref('');
            let nomeEquipamento = ref('');

            const toggleTheme = () => {
                isDarkMode.value = !isDarkMode.value;
                document.documentElement.classList.toggle("dark-mode", isDarkMode.value);
                localStorage.setItem("theme", isDarkMode.value ? "dark" : "light");
                eventBus.emit('mudou-tema', isDarkMode.value ? "dark" : "light");
            };

            const atualizarFiltro = () => {
                eventBus.emit('filtrar-equipamentos', message.value);
            };

            const clearMessage = () => {
                message.value = '';
            };

            eventBus.on("mudou-nome-equipamento", (novoNomeEquipamento) => {
                nomeEquipamento.value = novoNomeEquipamento;
            });

            return {
                isDarkMode,
                toggleTheme,
                atualizarFiltro,
                message,
                clearMessage,
                nomeEquipamento,
                logo: logoSrc,
            };
        }
    };
</script>

<style scoped>
.top-menu {
    background-image: linear-gradient(to right, #0069ad, #004a7a) !important;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 20px;
    color: #ffffff;
    gap: 10px;
}

.right {
    position: absolute;
    right: 15px;
    display: flex;
    align-items: center;
}

.center {
    display: flex;
    justify-content: center;
    flex: 1 1 auto;
}

.box-input {
    max-width: 500px;
    width: 100%;
    padding: 0 20px;
}

@media screen and (max-width: 640px) {
    .box-input {
        width: 120px;
    }
}

.box-nome-pagina {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 50%;
    justify-content: space-between;
}

.titulo {
    font-size: 20px;
    font-weight: 600;
    line-height: 23.44px;
}

.equipamento {
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    text-transform: capitalize;
}

.left {
    position: absolute;
    left: 100px;
    display: flex;
    align-items: center;
}

.logo {
    height: 30px;
    object-fit: contain;
}


@media screen and (max-width: 960px) {
    .box-nome-pagina {
        justify-content: center;
    }

    .equipamento {
        display: none;
    }
}
</style>